import { render } from "./Account.vue?vue&type=template&id=460d1cf4&bindings={\"ago\":\"data\",\"apiKey\":\"data\",\"profile\":\"data\",\"labels\":\"options\",\"logout\":\"options\",\"fetchApiKeys\":\"options\",\"createApiKey\":\"options\",\"deleteApiKey\":\"options\",\"updateProfile\":\"options\"}"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"
script.render = render

export default script